import InutilizacaoNFeService from "@/services/InutilizacaoNFeService";

export const inutilizacaoNFe = {
  namespaced: true,
  state: {
    inutilizacaonfe: {},
  },
  actions: {
    getInutilizacaoNFe({ commit }, payload) {
      return InutilizacaoNFeService.GetInutilizacaoNFe(payload).then(
        (inutilizacaonfe) => {
          return Promise.resolve(inutilizacaonfe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postInutilizacaoNFe({ commit }, payload) {
      return InutilizacaoNFeService.PostInutilizacaoNFe(payload).then(
        (inutilizacaonfe) => {
          return Promise.resolve(inutilizacaonfe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putInutilizacaoNFe({ commit }, payload) {
      return InutilizacaoNFeService.PutInutilizacaoNFe(payload).then(
        (inutilizacaonfe) => {
          return Promise.resolve(inutilizacaonfe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteInutilizacaoNFe({ commit }, payload) {
      return InutilizacaoNFeService.DeleteInutilizacaoNFe(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getInutilizacaoNFeOData({ commit }, payload) {
      return InutilizacaoNFeService.GetInutilizacaoNFeOData(payload).then(
        (inutilizacaonfe) => {
          return Promise.resolve(inutilizacaonfe);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default inutilizacaoNFe;
